import { buildCustomFieldDefaults } from "components/BaseForm";

export const FORM_MODES = {
  create: "create",
  edit: "edit",
};

const fromRecord = record => ({
  name: record.name ?? "",
  status: record.status ?? null,
  assigned_user_id: record.assigned_user_id ?? null,
  start_time: record.start_time ?? null,
  end_time: record.end_time ?? null,
  form_id: record.form_id ?? null,
  limit_email_templates: (record.info?.selected_templates ?? []).length > 0,
  email_templates: record.info?.selected_templates ?? [],
  email_service: record.email_service ?? null,
  email_type: record.email_type ?? "",
  region_id: record.region_id ?? null,
  case_campaign_status_preset: record.info?.case_campaign_status_preset ?? null,
  campaign_status_preset: record.info?.campaign_status_preset ?? null,
  revenue_status_preset: record.info?.revenue_status_preset ?? null,
  revenue_recipient_preset: record.info?.revenue_recipient_preset ?? null,
  description: record.info?.description ?? "",
});

/** Initial form values for each mode. */
export const buildDefaultValues = ({ mode, record, customFieldConfigs }) =>
  mode === FORM_MODES.edit
    ? {
        ...fromRecord(record),
        custom_fields: buildCustomFieldDefaults(
          customFieldConfigs,
          record.custom_fields
        ),
      }
    : {
        ...fromRecord({}),
        custom_fields: buildCustomFieldDefaults(customFieldConfigs, null),
      };
